<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col mx-auto">
          <div class="row justify-content-center">
            <div class="col-md-4">
              <div class="text-center mb-5">
                <img src="/images/brand/logo.png" class="header-brand-img desktop-lgo" alt="Enjoy the Street">
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="text-center mb-3">
                    <h1 class="mb-2">Anmelden</h1>
                    <span>Willkommen zurück!</span>
                  </div>
                  <div class="mt-5">
                    <div class="input-group mb-4">
                        <div class="input-group-text" style="width: 44px !important;">
                          <i class="far fa-user" style="margin-left: 2px"></i>
                        </div>
                      <input v-model="credentials.email"  type="text" class="form-control" placeholder="E-Mail" @keypress.enter="login()">
                    </div>
                    <div class="input-group mb-4">
                      <div class="input-group" id="Password-toggle1">
                        <a class="input-group-text" @click="togglePasswordShow" style="width: 44px !important;">
                          <i v-if="inputType == 'password'" class="far fa-eye"></i>
                          <i v-else class="far fa-eye-slash"></i>
                        </a>
                        <input v-model="credentials.password" class="form-control" :type="inputType" placeholder="Passwort" @keypress.enter="login()">
                      </div>
                    </div>
                    <!--
                      ENTFERNT: Kontrollkästchen "Angemeldet bleiben".
                      WAR FALSCH: Es war an nichts angeschlossen — login()
                      schreibt den Anmelde-Schlüssel immer ins localStorage
                      (Zeile weiter unten), unabhängig vom Haken. Ob angehakt
                      oder nicht, der Verwalter blieb so oder so angemeldet,
                      bis er sich abmeldet. Ein Kontrollkästchen ohne Wirkung
                      täuscht eine Wahlmöglichkeit vor, die es nicht gibt.
                    -->
                    <div class="form-group text-center mb-3">
                      <button class="btn btn-primary btn-lg w-100 br-7" @click="login()">Anmelden</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    routingTarget: String,
  },

  data() {
    return {
      showPassword: false,
      inputType: "password",

      credentials: {
        email: "",
        password: ""
      },
    };
  },

  mounted() {
    this.setLoginBodySettings(true);
    // this.$axios.checkBearer().then(this.onLoggedIn).catch(this.discardError);
  },

  methods: {
    login() {
      var _this = this;
      // WAR FALSCH: Ein leeres oder halb ausgefülltes Formular ging direkt
      // an den Server. Dort bricht die Anmeldeprüfung (passport-local) noch
      // VOR jedem eigenen Code des Projekts ab und meldet ihre eigene
      // Werksmeldung "Missing credentials" — auf Englisch, obwohl der Rest
      // der Seite deutsch ist (Quelle: ETSBackend/node_modules/passport-local/
      // lib/strategy.js, nicht im Projekt-Quelltext zu finden). Wer kein
      // Englisch kann, hielt das für einen kaputten Server. Jetzt prüft das
      // Dashboard die Pflichtfelder selbst und zeigt in dem Fall eine
      // deutsche Meldung, ohne den Server überhaupt zu fragen.
      if (!this.credentials.email || !this.credentials.email.trim() ||
          !this.credentials.password || !this.credentials.password.trim()) {
        this.$noty.error("Bitte E-Mail und Passwort eingeben.");
        return;
      }
      // ENTFERNT: this.$axios.credentials = this.credentials;
      // WAR TOTER CODE aus der Zeit von src/Http.js: Nur das dortige authorize()
      // las dieses Feld; axios kennt keine Option "credentials" (nur
      // "withCredentials"). FOLGE: Das Passwort lag im Klartext auf der globalen
      // axios-Instanz und blieb dort die ganze Sitzung über liegen — ohne dass
      // es irgendetwas bewirkt hätte.
      this.$axios.post('/signInDashboard', {
        email: this.credentials.email,
        password: this.credentials.password,
        fcmToken: ""
      }).then(function(response){
        // Dieses Backend antwortet bei einem fachlichen Fehlschlag (z. B.
        // falsches Passwort) mit HTTP 200 und success: false im Rumpf
        // (siehe respondFailure in ETSBackend/helpers/response.js). Für axios
        // zählt 200 als Erfolg, der .then()-Zweig lief also auch bei
        // falschem Passwort weiter. Dort griff response.data.data.token zu —
        // bei success: false fehlt data, das warf einen TypeError. Der
        // landete zwar in .catch(onError), aber ein TypeError hat kein
        // err.response, onError lief deshalb in den else-Zweig
        // (nur console.error) und auf dem Bildschirm passierte gar nichts.
        //
        // Jetzt wird success zuerst geprüft, BEVOR auf data.token zugegriffen
        // wird — die Meldung vom Server ist bereits auf Deutsch übersetzt.
        if (response.data == null || response.data.success === false) {
          const message = response.data != null && response.data.message != null
            ? response.data.message
            : "Anmeldung fehlgeschlagen.";
          _this.$noty.error(message);
          return;
        }
        localStorage.setItem("id_token", response.data.data.token);
        _this.onLoggedIn(response);
      }).catch(this.onError);
    },
    onLoggedIn(response) {
      this.$axios
        .get("/user/profile/my/0/5")
        .then(this.onSuccessfulLogin)
        .catch(this.onLoginFailed);
    },
    onError(err) {
      // Vorher lief ein Fehler ohne err.response (z. B. der TypeError aus dem
      // .then()-Zweig oben, oder ein nicht erreichbarer Server) nur in
      // console.error — auf dem Bildschirm blieb der Anmelden-Knopf ohne
      // jede sichtbare Reaktion. Jetzt gibt es in jedem Fall eine Meldung.
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
        this.$noty.error("Anmeldung fehlgeschlagen. Server nicht erreichbar oder unerwarteter Fehler.");
      }
    },
    onSuccessfulLogin(response){
      // FEHLER 4: Der Zugangsschlüssel wurde schon in login() gespeichert,
      // BEVOR dieser Profilabruf überhaupt lief. Lehnte der Server ihn
      // fachlich ab (HTTP 200, success:false — z. B. das Konto wurde
      // zwischenzeitlich gesperrt), setzte dieser Zweig trotzdem
      // Vue.prototype.$user = response.data.data, also auf undefined, und
      // leitete weiter. In App.vue hängen Menü und Kopfleiste an
      // "$user != null" — und "undefined != null" ist in JavaScript falsch.
      // Der Verwalter landete auf einer Seite ohne Menü und ohne Kopfleiste,
      // ohne jede Meldung, und der ungültige Schlüssel blieb im Speicher
      // liegen. Jetzt gilt die Anmeldung in diesem Fall nicht als gelungen.
      if (response.data == null || response.data.success === false) {
        this.onLoginFailed(response.data);
        return;
      }
      Vue.prototype.$user = response.data.data;
      this.setLoginBodySettings(false);
      if(this.routingTarget != null){
        this.$router.push(this.routingTarget);
        window.location.reload();
        return;
      }
      this.$router.push("dashboard");
    },
    onLoginFailed(error) {
      // Entfernt den in login() gespeicherten Zugangsschlüssel: Ohne gültiges
      // Profil gilt die Anmeldung nicht als gelungen, der Schlüssel darf also
      // nicht im Speicher bleiben (siehe Kommentar in onSuccessfulLogin).
      localStorage.removeItem("id_token");
      // WAR FALSCH: error.message wurde zuerst geprüft. Ein abgelehnter Aufruf
      // hat fast immer ein gesetztes error.message — die englische
      // Systemmeldung von axios (z. B. "Request failed with status code 401").
      // FOLGE: Die deutsche Übersetzung ERROR_INVALID_CREDENTIALS war auf
      // diesem Weg nie erreichbar, der Verwalter sah immer den englischen Text.
      // JETZT (gleiches Muster wie failureMessage() in Users.vue/Reported.vue):
      // zuerst die Servermeldung aus error.response.data.message (die
      // eigentliche, oft schon deutsche Ablehnung), erst ohne error.response
      // (reiner Netzwerk-/Verbindungsfehler) auf error.message, sonst die
      // Übersetzung.
      const message = (error && error.response && error.response.data && error.response.data.message)
        || (error && error.response == null && error.message)
        || this.$t("ERROR_INVALID_CREDENTIALS");
      this.$noty.error(message);
      // ENTFERNT: showLoadingCircle(false);
      // WAR FALSCH: Diese Funktion gibt es nirgends — weder in src/ noch in
      // public/ (Suche über das ganze Projekt: nur dieser eine Treffer).
      // FOLGE: ReferenceError mitten im Fehlerpfad der Anmeldung. Alles danach
      // lief nicht mehr, und in der Konsole stand ein Fehler, der wie ein
      // Anmeldeproblem aussah, obwohl er keines war.
    },
    logError(error) {
      console.log(error);
    },
    discardError(error) {},

    setLoginBodySettings(bool){
      if(bool){
        document.getElementById("app").classList.add("login");
      }else{
        document.getElementById("app").classList.remove("login");
      }
    },
    togglePasswordShow() {
      if(this.inputType == "password") {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    }
  },
};
</script>

<style>
</style>